module.exports = __webpack_public_path__ + "media/images/v2/illustration_1-198433dfc9a728de103213d8689e4cc4.svg";